<template>
  <div class="definition-input">
    <div class="definition-input__title typo-tiny">
      {{ data.label }}
      <em v-if="data.secondaryLabel">{{ data.secondaryLabel }}</em>
    </div>
    <div class="definition-input__container">
      <RangeSlider
        :maxValue="data.maxValue"
        :minValue="data.minValue || 0"
        :step="data.step || 1"
        v-model="modelValue"
        @input="update"
        :id="data.id"
      />
      <input
        :aria-label="$t('general.labels.number')"
        :id="data.id"
        :max="data.maxValue"
        :min="data.minValue || 0"
        :step="data.step || 1"
        @input="update"
        class="input typo-ignore typo-tiny"
        type="number"
        v-model="modelValue"
      />
    </div>
  </div>
</template>

<script setup>
import RangeSlider from '@/components/form/range_slider.vue';

defineProps({
  data: { type: Object, required: true },
  modelValue: { type: [String, Number], required: false, default: '' },
});

const emit = defineEmits(['update:modelValue']);

function update(e) {
  emit('update:modelValue', e.target.value);
}
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.definition-input {
  background-color: map-get($background-color, dark);
  border-radius: map-get($border-radius, heavy);
  margin-bottom: bu(0.5);
  padding: bu(1.75) bu(1.75);

  &__title {
    margin-bottom: bu(0.5);

    em {
      color: map-get($foreground-color, dark);
      margin-left: bu(0.5);
    }
  }

  &__container {
    align-items: center;
    display: grid;
    gap: bu(2);
    grid-template-columns: 1fr rem(70);

    input {
      width: 100%;

      &[type='number'] {
        -moz-appearance: auto;
        -webkit-appearance: auto;
        appearance: auto;
        color: map-get($foreground-color, light);
        height: bu(3.75);
        padding: bu(1);
      }
    }
  }
}
</style>
